@if (changes(); as changes) {
  @if (kpisUnavailable()) {
    <p data-testid="kpis-unavailable" class="text-text-secondary mb-2 text-[11px]">
      {{ 'features.plan.panel.kpis.unavailable' | translate }}
    </p>
  } @else if (!changes.settled) {
    <p role="status" class="text-text-tertiary mb-2 text-[11px]">
      {{ 'features.plan.kpis.provisional' | translate }}
    </p>
  }
} @else if (mode() !== 'stored') {
  <p class="mb-2">
    <span
      data-testid="kpis-mode"
      class="bg-warning-soft text-warning rounded-full px-2 py-0.5 text-[11px] font-semibold">
      {{
        (mode() === 'saved-plan'
          ? 'features.plan.kpis.saved_plan'
          : 'features.plan.kpis.live_label'
        ) | translate
      }}
    </span>
  </p>
}

<div class="grid grid-cols-2 gap-1.5 transition-opacity" [class.opacity-60]="muted()">
  @for (tile of tiles(); track tile.id) {
    <div
      #tileEl
      data-testid="kpi-tile"
      class="border-default min-w-0 rounded-md border px-2 py-1.5"
      [class]="
        tile.detail.length > 0
          ? 'hover:bg-interactive cursor-pointer transition-colors'
          : ''
      "
      [attr.role]="tile.detail.length > 0 ? 'button' : null"
      [attr.tabindex]="tile.detail.length > 0 ? 0 : null"
      [attr.aria-haspopup]="tile.detail.length > 0 ? 'dialog' : null"
      (click)="toggleDetail(tile, tileEl)"
      (keydown.enter)="onTileKeydown(tile, $event)"
      (keydown.space)="onTileKeydown(tile, $event)">
      <div
        class="text-text-secondary mb-0.5 truncate text-[11px]"
        [title]="tile.i18nKey | translate">
        {{ tile.i18nKey | translate }}
      </div>
      <div class="flex flex-wrap items-baseline gap-x-1">
        <span
          data-testid="kpi-tile-value"
          class="text-text-primary font-mono text-lg leading-tight font-semibold tabular-nums"
          >{{ tile.prefix }}{{ tile.value
          }}<small class="text-text-secondary text-[11px] font-medium">{{
            tile.suffix
          }}</small></span
        >
        @if (tile.delta !== null) {
          <span
            data-testid="kpi-tile-delta"
            class="rounded-xs px-1 font-mono text-[11px] font-semibold tabular-nums"
            [class]="TONE_CLASSES[tile.tone ?? 'flat']"
            >{{ tile.delta }}</span
          >
        }
      </div>
      @if (changes()) {
        <div
          class="text-text-secondary mt-0.5 flex flex-col font-mono text-[10.5px] tabular-nums">
          <span
            data-testid="kpi-tile-saved"
            class="truncate"
            [class.text-text-primary]="reference() === 'saved'">
            {{
              'features.plan.panel.kpis.saved'
                | translate: { value: affixed(tile, tile.saved) }
            }}
          </span>
          @if (hasRound()) {
            <span
              data-testid="kpi-tile-before"
              class="truncate"
              [class.text-text-primary]="reference() === 'before'">
              {{
                'features.plan.panel.kpis.before'
                  | translate: { value: affixed(tile, tile.before) }
              }}
            </span>
          }
        </div>
      }
    </div>
  } @empty {
    <p data-testid="kpis-none" class="text-text-tertiary col-span-2 text-xs">
      {{ 'features.plan.panel.kpis.none' | translate }}
    </p>
  }
</div>
